import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./locale/en_US";
import es from "./locale/es_ES";
import store from "../store";

Vue.use(VueI18n);

export default new VueI18n({
  locale: store.getters.lang,
  fallbackLocale: "es",
  messages: {
    en: {
      lang: en
    },
    es: {
      lang: es
    }
  }
});
